import { Component, Input, OnInit, Output, TemplateRef,EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-CalibrationDeviceBehfa',
  templateUrl: './CalibrationDeviceBehfa.component.html',
  styleUrls: ['./CalibrationDeviceBehfa.component.scss']
})
export class CalibrationDeviceBehfaComponent implements OnInit {

  @Input() inner_Kartable_Order_Interface: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  @Input() inner_Persian_Date: string = ""
  @Input() inner_Can_Add_Edit: boolean=true

  @Output() OnBack_CalibrationDeviceBehfa_Action = new EventEmitter<number>();
  Data_Change_Operaion_Id:number=-1
  Procssing:boolean=false
  modalRef_Cancel: any;

  constructor(
    private Alertify_Service:AlertifyService,
    private Calibration_Service:CalibrationService,
    private DeviceBehfa_Service: DeviceBehfaService,
    private modalService: BsModalService
  ) { }



  ngOnInit() {
    this.ReadData_Calibration_Device()
  }

  OnSet_Back_CalibrationList(){
    this.OnBack_CalibrationDeviceBehfa_Action.emit(-1);
  }

  //#region Calibration

  modalRef_Delete:any
  Processing_Detail:boolean=false


  Selected_Calibration_Device:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()
  DataList_Calibration_Device:Array<DeviceBehfa_Interface>=[]
  ReadData_Calibration_Device(){
    this.DataList_Calibration_Device=[]
    this.Processing_Detail=true
    this.Calibration_Service.GetCalibrationDeviceBehfa(this.inner_Kartable_Order_Interface.calibration_detail_id).subscribe(
      data=>{
        this.Processing_Detail=false
        this.DataList_Calibration_Device=data
        this.ReadData_Calibration_Device_Scan()
      }
    )
  }
  
  DataList_Calibration_Device_Scan:Array<DeviceBehfa_Interface>=[]
  ReadData_Calibration_Device_Scan(){
    this.DataList_Calibration_Device_Scan=[]
    this.Processing_Detail=true
    this.Calibration_Service.GetCalibrationDeviceBehfaScan(this.inner_Kartable_Order_Interface.calibration_detail_id).subscribe(
      data=>{
        this.Processing_Detail=false
        this.DataList_Calibration_Device_Scan=data
      }
    )
  }


  DeviceBehfa_Delete_Dsc:string=''

  Delete(item: DeviceBehfa_Interface) {

    if (this.DeviceBehfa_Delete_Dsc.trim().length < 50) {
      this.Alertify_Service.ErrorMessage("توضیحات را (حداقل 50 کاراکتر) وارد نمائید.")
    }
    else {
      this.Processing_Detail = true
      this.modalRef_Delete.hide()
      this.Calibration_Service.PostCalibrationDeviceBehfaRemove(item.id,
        this.DeviceBehfa_Delete_Dsc).subscribe(
        data => {
          this.DeviceBehfa_Delete_Dsc=''
          this.Alertify_Service.SuccessMessage("حذف شد")
          this.ReadData_Calibration_Device()
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Selected_Calibration_Device=Record
    this.modalRef_Delete = this.modalService.show(template);
    this.DeviceBehfa_Delete_Dsc=""
  }

  //#endregion


 //#region  Device Behfa

 modalRef_DeviceBehfa: any;

 Procssing_DeviceBehfa: boolean = false

 Search_Code_DeviceBehfa_Table: string = ''

  openModal_DeviceBehfa(template: TemplateRef<any>) {
   this.DeviceBehfa_Delete_Dsc=""
   this.modalRef_DeviceBehfa = this.modalService.show(template);
   this.DataList_DeviceBehfa = []
 }

 DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []
 //Data_Seleted_DeviceBehfa_Record: DeviceBehfa_Interface = Empty_DeviceBehfa_Interface()

 ReadData_DeviceBehfa_KeySearch_Timer: any
 ReadData_DeviceBehfa_KeySearch() {

   if (this.ReadData_DeviceBehfa_KeySearch_Timer) {
     clearTimeout(this.ReadData_DeviceBehfa_KeySearch_Timer);
     this.ReadData_DeviceBehfa_KeySearch_Timer = null;
   }

   this.ReadData_DeviceBehfa_KeySearch_Timer = setTimeout(function () {
     this.ReadData_DeviceBehfa()
   }.bind(this), 1000);

 }

 ReadData_DeviceBehfa() {


   if (!this.Search_Code_DeviceBehfa_Table) {
     this.DataList_DeviceBehfa = []


   }
   else {
     this.Procssing_DeviceBehfa = true

     this.DeviceBehfa_Service.GetSearchBehfaDeviceActive(this.Search_Code_DeviceBehfa_Table,this.inner_Persian_Date,false,0,0).subscribe(
         data => {

           this.DataList_DeviceBehfa = data
           this.Procssing_DeviceBehfa = false
         }, error => {
           // AuthInterceptor owns authentication; feature errors must preserve credentials.

         }
       )
   }
 }

  Set_Selected_DeviceBehfa_Record(item: DeviceBehfa_Interface) {
    this.Processing_Detail = true
    this.Calibration_Service.PostCalibrationDeviceBehfaAdd(item.id,
      this.inner_Kartable_Order_Interface.calibration_detail_id,
      this.DeviceBehfa_Delete_Dsc).subscribe(
      data => {
        this.Processing_Detail = false
          if (data['code'] == 'yes') {
           this.DeviceBehfa_Delete_Dsc=''
          this.Alertify_Service.SuccessMessage("تجهیز به ماموریت افزوده شد")
          this.ReadData_Calibration_Device()
        }
        else if (data['code'] == 'no') {
          this.Alertify_Service.ErrorMessage("تجهیز در مامریت ثبت شده است")
          }
          else {
           this.Alertify_Service.ErrorMessage("تجهیز در ماموریت دیگر استفاده شده است")
          }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "BehfaDevice.xlsx");

  }

 page:0
 //#endregion

 Set_Change_Operaion(item:number){
  this.Data_Change_Operaion_Id=item
}

OnBack_Change_Operaion(item:any) {
  this.Data_Change_Operaion_Id=-1
}


}
